import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { ICreditCardDTO } from '../../../models/ICreditCardDTO';

@Injectable({
  providedIn: 'root'
})
export class CreditCardsService {

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);


  creditCardsListSignal = signal<ICreditCardDTO[] | null>(null);

  constructor() { }

  public getCreditCards(): Observable<ICreditCardDTO[]> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/credit-cards`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<ICreditCardDTO[]>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.creditCardsListSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  public patchCreditCard(data: ICreditCardDTO): Observable<any> {

    const url = `${environment.apiUrl}/v3/accounts/my-account/credit-cards/`+data.creditCardInfo.id;

    let bodyString = new HttpParams({
      encoder: new HttpUrlEncodingCodec(),
    });
    bodyString = bodyString
      .append('cardData', JSON.stringify(data))
    
    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          });
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);
          return this.http.patch<string>(url, bodyString.toString(), {
            headers,
            responseType: 'text' as 'json'
          });
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),

    )
  }

  deleteCard(cardId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/credit-cards/${cardId}`;
    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');
          return this.httpService.deleteWithDetailedErrors<string>(url, null, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      }),
      tap(response => {
        
      })
    );
  }


}


